<template>
	<div :id="blok._uid" class="col-span-full px-sm md:mx-md lg:px-0 2xl:mx-0">
		<div
			class="grid grid-cols-2 gap-x-10 gap-y-lg pb-2xl md:grid-cols-3 md:gap-y-0"
		>
			<p
				v-if="blok.title"
				class="col-span-full text-center font-sans-caption text-xl leading-7 font-bold md:mb-lg lg:mb-lg lg:text-2xl"
			>
				{{ blok.title }}
			</p>

			<div
				v-for="content in blok.content"
				:key="content._uid"
				class="my-xs flex flex-col items-center justify-start lg:justify-center"
			>
				<v-storyblok-component :blok="content" />
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import type {BlokComponent} from "@pkg/shared/types";

defineProps<{
	blok: Extract<
		BlokComponent,
		{component: "sb-text-columns" | "sb-text-column"}
	>;
}>();
</script>
